/**
Ref: https://medium.com/front-end-weekly/html5-form-validation-in-react-65712f778196
     https://time2hack.com/form-with-react-html5-validations/
     https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation

Note: default props inputRef, onChange, error HelperText can be overridden by passing it in props
*/

import { FormControl, FormLabel } from '@chakra-ui/form-control';
import { VStack } from '@chakra-ui/layout';
import { Radio, RadioGroup } from '@chakra-ui/radio';
import React, { useState } from 'react';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import FormControl from '@material-ui/core/FormControl';
// import FormLabel from '@material-ui/core/FormLabel';

const FormRadioField = ({ values, ...props }) => {
  const [value, setValue] = useState(props?.defaultValue || '');

  const handleChange = (value) => {
    setValue(value);
    // handle funcForValueFunc params
    if (props?.funcForValueFunc && props?.funcForValue === value) {
      props.funcForValueFunc();
      // handle custom onChange function
    } else if (props?.onChange) {
      props.onChange(value);
    }
  };

  return (
    <FormControl as="fieldset">
      <FormLabel as="legend">{props.label}</FormLabel>
      <RadioGroup
        aria-label={props.label}
        name={props.name}
        value={value}
        onChange={(value) => {
          handleChange(value);
        }}
        defaultValue={value}
      >
        <VStack align="flex-start">
          {values.map((item) => {
            let optionValue = item;
            let optionLabel = item;
            if (typeof item === 'object') {
              Object.keys(item).forEach((key) => {
                optionValue = key;
                optionLabel = item[key];
              });
            }

            return <Radio value={optionValue}>{optionLabel}</Radio>;
          })}
        </VStack>
      </RadioGroup>
    </FormControl>
  );
};

export default FormRadioField;
